{
    "DefaultSet_Standard_Reports": "Relatórios padrão",
    "DefaultSet_Power_User_Reports": "Relatórios de usuários avançados",
    "DefaultSet_Contact_Centre_Reports": "Relatórios do Contact Center",
    "DefaultSet_Call_Centre_Reports": "Relatórios da Central de Atendimento",
    "DefaultSet_SIP_Reports": "Relatórios SIP",
    "NAME": "ReportingDefaultReportSets",
    "DefaultSet_Enhanced_Call_Centre_Reports": "Relatórios melhorados do centro de atendimento",
    "DefaultSet_Call_Centre_Agent_Reports": "Relatórios de agentes do centro de atendimento",
    "DefaultSet_Essentials_Reports_MST": "Relatórios padrão CXA",
    "DefaultSet_Professional_Reports_MST": "Relatórios CXA não utilizados",
    "DefaultSet_Call_Centre_Agent_Reports_MST": "Relatórios Premium CXA",
    "DefaultSet_Call_Center_Reports": "Relatórios do centro de atendimento",
    "DefaultSet_Enhanced_Call_Center_Reports": "Relatórios melhorados do centro de atendimento"
}